import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';
import {
  SectionContainer,
  SectionTitle,
  SectionDetails,
} from '../../shared/sectionable/styles';
import ExpandableContainer from '../../../shared/expandable-container';

const LW_DISCLAIMER = 'Livewire gives readers access to content provided by '
  + 'financial services professionals and companies ("Livewire Contributors”). '
  + 'Fund data is provided by Morningstar for personal use only. While every '
  + 'care has been taken in producing these numbers, neither Livewire nor '
  + 'Morningstar can guarantee the complete accuracy of these figures. Should '
  + 'you decide to invest, please read the relevant disclosure documents and '
  + 'consider speaking to a professional. A tax event may be realised when '
  + 'switching investments. Past performance is not a reliable indicator of '
  + 'future performance. Livewire does not operate under an Australian '
  + 'Financial Services Licence (AFSL) and relies on the exemption under '
  + '911A(2)(eb) of the Corporations Act 2001 in respect to any advice given. '
  + 'The advice on this site is general in nature and does not take into '
  + 'account your personal needs or objectives.';

const SSectionTitle = styled(SectionTitle)`
  ${props => props.theme.isMobile && `
    border: none;
    margin: unset;
    padding: unset;
  `};
`;

const SSectionDetails = styled(SectionDetails)`
  padding-left: 24px;
  border-left: 1px solid #CDD7E0;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 14px;
  color: #9BAFBF;
  margin: 0;

  ${props => !props.theme.isMobileOrTablet && `
    padding-right: 6vw;
  `};

  .showless {
    margin-top: 12px;
  }

  .readmore-more-anchor, .readmore-less-anchor {
    text-transform: capitalize;
  }
`;

const Content = styled.div`
  white-space: pre-wrap;
`;

export default function Disclaimer({ disclaimer, lw }) {
  const { isMobile } = React.useContext(ThemeContext);

  if (!lw && (!disclaimer || disclaimer.trim().length === 0)) {
    return null;
  }

  return (
    <SectionContainer>
      <SSectionTitle />
      <SSectionDetails>
        {
          lw
            ? <Content>{LW_DISCLAIMER}</Content>
            : (
              <ExpandableContainer lines={isMobile ? 7 : 3}>
                {/* eslint-disable-next-line react/no-danger */}
                <Content dangerouslySetInnerHTML={{ __html: disclaimer }} />
              </ExpandableContainer>
            )
        }
      </SSectionDetails>
    </SectionContainer>
  );
}

Disclaimer.propTypes = {
  disclaimer: PropTypes.string,
  lw: PropTypes.bool,
};

Disclaimer.defaultProps = {
  disclaimer: null,
  lw: false,
};
